export const APP_NAME = 'Layerit'

export const APP_ID = 'layerit'

export const APP_DOMAIN = 'layerit.app'

export const APP_URL = `https://${APP_DOMAIN}`

export function appEmail(mailbox: string): string {
	return `${mailbox}@${APP_DOMAIN}`
}

export function appKey(name: string): string {
	return `${APP_ID}-${name}`
}
